<template>
    <ModalBase
        name="editarInfo"
        title="Editar información de pago"
        @close="closeHandler"
    >
        <!-- Confirmation step -->
        <template v-if="!editInfoPago">
            <p class="tw:text-sm tw:text-gray-600 tw:mb-6">
                ¿Estás seguro de que quieres modificar la tarjeta?
                Este cambio afectará al cobro de deportistas, abonos, etc. del usuario.
            </p>
        </template>

        <!-- Payment form step (new card) -->
        <template v-if="editInfoPago && !iframeUrl">
            <PagoPaycometForm
                ref="pagoFormRef"
                :jet_id="jetId"
                @payToken="onPayToken"
            />
        </template>

        <!-- 3DS Challenge iframe -->
        <template v-if="iframeUrl">
            <div class="tw:flex tw:justify-center">
                <iframe
                    :src="iframeUrl"
                    width="325"
                    height="523"
                    frameborder="0"
                    class="tw:shadow tw:bg-white tw:rounded"
                    sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms"
                ></iframe>
            </div>
        </template>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button
                    variant="ghost"
                    @click="closeHandler"
                >
                    Cancelar
                </Button>
                <Button
                    v-if="!editInfoPago"
                    @click="confirmarEdit"
                    :disabled="loading"
                >
                    {{ loading ? 'Cargando...' : 'Continuar' }}
                </Button>
                <Button
                    v-if="editInfoPago && !iframeUrl"
                    @click="onSubmit"
                    :disabled="procesando"
                >
                    {{ procesando ? 'Procesando...' : 'Guardar tarjeta' }}
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import PagoPaycometForm from '@/modules/front/perfil/components/CambiarDatos/PagoPaycometForm.vue';

    const props = defineProps({
        tid: { type: String, required: true },
        userId: { type: [String, Number], required: true },
        nuevaAlta: { type: Boolean, default: false },
    });

    const emit = defineEmits(['close', 'setActive']);

    const pagoFormRef = ref(null);
    const editInfoPago = ref(false);
    const jetId = ref(null);
    const loading = ref(false);
    const procesando = ref(false);
    const iframeUrl = ref('');

    async function confirmarEdit() {
        loading.value = true;

        try {
            const data = {
                tid: props.tid,
                user_id: props.userId,
                filters: {},
            };

            const res = await store.dispatch(
                config.getVuexAlias('front.perfil.get-jet-id'),
                data,
            );

            jetId.value = res.data.jet_id;
            editInfoPago.value = true;
        } catch (e) {
            // Error silencioso
        } finally {
            loading.value = false;
        }
    }

    function onSubmit() {
        if (pagoFormRef.value) {
            pagoFormRef.value.submit();
        }
    }

    async function onPayToken(jetToken) {
        procesando.value = true;

        try {
            const params = {
                filters: {},
                jetToken,
                tid: props.tid,
                user_id: props.userId,
                nueva_alta: props.nuevaAlta,
            };

            const res = await store.dispatch(
                config.getVuexAlias('back.usuarios.procesar-confirmacion-tarjeta'),
                params,
            );

            const response = res.data.response;

            if (response.challengeUrl) {
                iframeUrl.value = response.challengeUrl;
                emit('setActive');
            } else if (response.compraFinalizada) {
                onCardConfirmed();
            }
        } catch (e) {
            // Error silencioso
        } finally {
            procesando.value = false;
        }
    }

    function onCardConfirmed() {
        editInfoPago.value = false;
        jetId.value = null;
        iframeUrl.value = '';
        emit('close');
    }

    function closeHandler() {
        editInfoPago.value = false;
        jetId.value = null;
        iframeUrl.value = '';
        emit('close');
    }
</script>
